import { time } from "@complex/Actions/Modal/logics/constants";
import type { IModalActionForm, IModalActionResolver } from "@complex/Actions/Modal/logics/types";
import { StackGrid } from "@data-display/layout/StackGrid";
import { DateInputForm, TextFieldForm } from "@inputs/hook-form";
import { MenuItem } from "@mui/material";
import { Box } from "@mui/material";
import { type Control, useWatch } from "react-hook-form";

interface INextActionDateProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const NextActionDate = ({ control }: INextActionDateProps) => {
  const nextAction = useWatch({
    control,
    name: "nextAction",
  });

  if (!nextAction) {
    return null;
  }

  return (
    <StackGrid perLine={2} gap={1} direction="row">
      <DateInputForm
        control={control}
        name="nextActionDate"
        label="Date de la prochaine action *"
        slotProps={{
          clearButton: { sx: { mr: 1.5, p: 0.5, opacity: "1 !important" } },
          field: { clearable: true },
        }}
        TextFieldProps={{ size: "small" }}
        disablePast
      />
      <TextFieldForm
        name="nextActionStartTime"
        label={
          <Box
            sx={{
              pr: 1,
            }}
          >
            Heure
          </Box>
        }
        size="small"
        control={control}
        select
        SelectProps={{
          // biome-ignore lint/style/useNamingConvention: <explanation>
          MenuProps: {
            slotProps: {
              paper: {
                sx: { maxHeight: "200px" },
              },
            },
          },
        }}
        clearable
      >
        {time.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextFieldForm>
    </StackGrid>
  );
};
